/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Dictionary } from '@gh/common-shared';
import { EditableCellOptionSet } from '@gh/core-ui-grid';
import { constant } from 'lodash';

export function buildOptionSetFromDictionary(dictionary: Dictionary<any>): EditableCellOptionSet {
  const optionSet = dictionary.seq();
  return {
    getOptions: constant(optionSet),
    hasOptions: constant(dictionary.seq().length > 0),
    format: ({ data, colDef: { field } }) => field ? dictionary.get(data[field]) : '',
  };
}
